import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const SolutionCard = ({ solution, index }) => {
  return (
    <Link 
      to={solution.link}
      className="group block relative overflow-hidden"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className="aspect-[4/5] overflow-hidden">
        <img
          src={solution.image}
          alt={solution.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8">
        <h3 className="text-2xl font-light text-white mb-2 group-hover:text-sky-400 transition-colors duration-300">
          {solution.title}
        </h3>
        <p className="text-gray-300 font-light text-sm mb-4 line-clamp-2">
          {solution.description}
        </p>
        <span className="inline-flex items-center text-sky-400 text-sm font-medium group-hover:gap-3 gap-2 transition-all duration-300">
          Scopri di più
          <ArrowRight className="w-4 h-4" />
        </span>
      </div>
    </Link>
  );
};

export default SolutionCard;
